"use client";

import { Provider } from "react-wrap-balancer";

const BalancerProvider = ({ children }: { children: React.ReactNode }) => {
  return <Provider>{children}</Provider>;
};

export default BalancerProvider;
